import { CompanyType } from 'context/authentication/Company.types'
import { Role } from 'context/authentication/Role.types'
import { getSelectedCompany } from 'context/authentication/User.helpers'

export const isCompanyType = (type: CompanyType) => getSelectedCompany()?.type === type

export const hasAccess = (role: Role): boolean => {
  const currentRole = getSelectedCompany()?.role
  if (!currentRole) {
    return false
  }
  switch (role) {
    case Role.Admin:
      return currentRole === Role.Admin
    case Role.Editor:
      return currentRole === Role.Editor || currentRole === Role.Admin
    case Role.Viewer:
      return currentRole === Role.Viewer || currentRole === Role.Editor || currentRole === Role.Admin
    default:
      return false
  }
}

export const isPublicPath = (path: string) =>
  [
    '/login',
    '/reset',
    '/wl',
    '/ql',
    '/deca',
  ].some((prefix) => path.startsWith(prefix))
